module.exports = [
  require('./tasha_s_caustic_brew'),
  require('./tasha_s_mind_whip'),
  require('./tasha_s_otherworldly_guise'),
]
